module.exports = __webpack_public_path__ + "img/Utah outline.dfd6b94a.png";